import { Typography } from '@mui/material';
import React from 'react';

const HideSummaryOrNoSummaryText = ({
	hideSummaryUntilSubmitted,
	noSummaryText,
	feedbacksSummary,
	hideNoRatings,
}) => {
	if (feedbacksSummary?.hideSummary) {
		return (
			<Typography variant="body1" sx={{ overflowWrap: 'break-word' }}>
				{hideSummaryUntilSubmitted}
			</Typography>
		);
	}

	if (!hideNoRatings) {
		return (
			<Typography variant="body1" sx={{ overflowWrap: 'break-word' }}>
				{noSummaryText}
			</Typography>
		);
	}

	return null;
};

export default HideSummaryOrNoSummaryText;
